import { cn } from '@/shadcn/lib/utils';
import { HTMLAttributes, PropsWithChildren } from 'react';

type Props = HTMLAttributes<HTMLDivElement> &
  PropsWithChildren<{
    loading?: boolean;
  }>;

export const NavbarSection = ({
  children,
  loading = false,
  className,
  ...props
}: Props): JSX.Element => {
  return (
    <div
      className={cn(
        'flex shrink-0 grow-0 items-center opacity-100 transition-opacity',
        loading && 'opacity-0',
        className
      )}
      data-cy="atomic-navbar-section"
      {...props}
    >
      {children}
    </div>
  );
};
